import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-not-allowed',
  standalone: false,
  templateUrl: './not-allowed.component.html',
  styleUrl: './not-allowed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAllowedComponent {}
